import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
`;

export const inputsDate = styled.div`
	width: 100%;
	display: flex;
	gap: 1rem;
	align-items: center;
	justify-content: center;
`;

export const twoInputs = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 1.5rem;

	@media (max-width: 1000px) {
		grid-template-columns: 1fr;
	}
`;
